// Google Analytics
const utils = {
    getLink({ website, utm_source = 'ridable.com.au', medium = 'cpc', campaign }) {
        // Function to return a valid link with its right structure for analytics
        return `${website}?utm_source=${utm_source}&utm_medium=${medium}&utm_campaign=${campaign}`;
    },
};

export { utils };
